export default "__VITE_ASSET__zwgj5Tz5__"